import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useAppSelector } from '../hooks';
import { DialogPanelEdit } from '../components/DialogPanelEdit';
import { Link } from 'react-router-dom';
export const ConfigPanels = (_props) => {
    const panels = useAppSelector(state => state.definitions.panels.entities);
    // The dialog data is stored here so we can set it depending on
    // what edit button we press
    const [open, setOpen] = useState(false);
    const [panelId, setPanelId] = useState(null);
    const [panelData, setPanelData] = useState({ title: '' });
    function create() {
        setPanelId(null);
        setPanelData({ title: '' });
        setOpen(true);
    }
    function edit(id) {
        var _a, _b;
        const title = (_b = (_a = panels[id]) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : '';
        setPanelId(id);
        setPanelData({ title });
        setOpen(true);
    }
    const rows = [];
    for (const m of Object.values(panels)) {
        const link = '/config/panel/' + m.id;
        rows.push(_jsxs("div", { children: [_jsx("div", { children: _jsx(Link, { to: link, children: m.title }) }), _jsx("div", { children: _jsx("button", { className: "lw small", onClick: () => edit(m.id), children: "Redigera" }) })] }, m.id));
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx(DialogPanelEdit, { panelId: panelId, isOpen: open, onClose: () => setOpen(false), panelData: panelData, setPanelData: setPanelData }), _jsx("div", { className: "operations", children: _jsx("button", { className: "lw success", onClick: create, children: "L\u00E4gg till panel..." }) }), _jsx("div", { className: "config-rows config-panels", children: rows })] }));
};
